<template>
  <sweet-modal ref="modal" overlay-theme="dark" :enable-mobile-fullscreen="false">
    <img :src="imageUrl" alt="" class="img-instant-booking">
    <hr>
    <h3>{{ $t('message.instant_booking.title') }}</h3>
    <div class="text-remark">{{ $t('message.instant_booking.detail') }}</div>
  </sweet-modal>
</template>

<script>
  import { SweetModal } from 'sweet-modal-vue'

  export default {
    components: {
      SweetModal
    },
    computed: {
      imageUrl () {
        return (this.$i18n.locale === 'en') ? '/static/img/dialog_instant_booking_en.png' : '/static/img/dialog_instant_booking_th.png'
      }
    },
    methods: {
      openModal () {
        this.$refs.modal.open()
      },
      closeModal () {
        this.$refs.modal.close()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modal/InstantBookingModal.vue